export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20631)">
                <path
                    d="M27.5625 32H8.4375C7.50552 32 6.75 31.2445 6.75 30.3125V6.6875C6.75 5.75552 7.50552 5 8.4375 5H27.5625C28.4945 5 29.25 5.75552 29.25 6.6875V30.3125C29.25 31.2445 28.4945 32 27.5625 32Z"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6.75 25.25H29.25" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22.5 28.625H25.875" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="1.125" cy="1.125" r="1.125" transform="matrix(1 0 0 -1 9 29.75)" fill="black" />
                <circle cx="1.125" cy="1.125" r="1.125" transform="matrix(1 0 0 -1 12.375 29.75)" fill="black" />
                <circle cx="1.125" cy="1.125" r="1.125" transform="matrix(1 0 0 -1 15.75 29.75)" fill="black" />
                <circle cx="6.75" cy="6.75" r="6.75" transform="matrix(1 0 0 -1 11.25 21.875)" stroke="black" strokeWidth="1.6875" />
            </g>
            <defs>
                <clipPath id="clip0_1975_20631">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
